/**
 * Create formatted price string with proper currency formatting
 *
 * @since 1.0.0
 */

import type { CurrencyFormatOptions } from './types';

/**
 * Create formatted price string with proper currency formatting
 *
 * @param amount - Amount to format
 * @param options - Currency formatting options
 */
export const formatCurrencyPrice = (
  amount: number,
  options: CurrencyFormatOptions = {}
): string => {
  const {
    currencySymbol = '$',
    currencyPrefix = '',
    currencySuffix = '',
    decimalSeparator = '.',
    thousandSeparator = ',',
  } = options;

  const formatted = amount
    .toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace(',', thousandSeparator)
    .replace('.', decimalSeparator);

  const suffix = currencySuffix || currencySymbol;
  return `${currencyPrefix}${formatted}${suffix}`;
};
